import React from "react";
import { Link } from "react-router-dom";
import { FaYoutube } from "react-icons/fa";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className=" text-white py-4 ">
      <div className="container mx-auto text-center">
        <ul className="flex-wrap md:flex-nowrap flex justify-center space-x-4 md:space-x-8 ">
          <li>
            <Link to="/imprint" className="text-gray-400 hover:text-white">
              Imprint
            </Link>
          </li>
          <li>
            <Link to="/privacy" className="text-gray-400 hover:text-white">
              Privacy Policy
            </Link>
          </li>
          <li>
            <a
              href="https://www.youtube.com/@pwcprofiles/videos"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white"
              aria-label="Visit our YouTube channel"
            >
              <FaYoutube size={24} />
            </a>
          </li>
          <li>
            <p>&copy; {currentYear} PWC-Profiles</p>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
